<div class="page-shell">
  <mat-toolbar class="header">
    <button
      mat-icon-button
      type="button"
      routerLink="/admin/print-card-orders"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>{{
      order?.printCardOrderId
        ? ("printCardOrders.detailTitle" | translate) +
          ": " +
          order.printCardOrderId
        : ("printCardOrders.detailTitle" | translate)
    }}</span>
  </mat-toolbar>

<div class="detail-wrapper">
  <ng-template #upsHelp let-path="path">
    <mat-icon
      class="field-help"
      [matTooltip]="('printCardOrders.shipment.hint.' + path) | translate"
      matTooltipPosition="above"
      [attr.aria-label]="('printCardOrders.shipment.hint.' + path) | translate"
    >help_outline</mat-icon>
  </ng-template>

  <ng-template #requiredError let-form="form" let-field="field">
    <mat-error *ngIf="form.hasError('required', [field])">
      {{ "fieldRequired" | translate }}
    </mat-error>
  </ng-template>

  <ng-template #phoneErrors let-form="form" let-field="field">
    <mat-error *ngIf="form.hasError('required', [field])">
      {{ "fieldRequired" | translate }}
    </mat-error>
    <mat-error *ngIf="form.hasError('phoneNumberInvalid', [field])">
      {{ "phoneNumberInvalid" | translate }}
    </mat-error>
  </ng-template>

  <ng-template #emailErrors let-form="form" let-field="field">
    <mat-error *ngIf="form.hasError('required', [field])">
      {{ "fieldRequired" | translate }}
    </mat-error>
    <mat-error *ngIf="form.hasError('email', [field])">
      {{ "emailInvalid" | translate }}
    </mat-error>
  </ng-template>

  <div class="detail-layout" *ngIf="order">
    <aside
      class="detail-sidebar"
      *ngIf="order.fulfillment?.timeline?.length"
    >
      <section class="fulfillment-section card-panel">
  <div class="fulfillment-header">
    <h2>{{ "printCardOrders.fulfillment.title" | translate }}</h2>
    <span class="stage-badge" [attr.data-stage]="order.status">
      {{ getFulfillmentStageLabelKey(order.status) | translate }}
    </span>
  </div>

  <p class="fulfillment-debug-hint" *ngIf="showDebugAdvanceHint">
    {{ "printCardOrders.fulfillment.debugHint" | translate }}
  </p>

  <ol class="fulfillment-timeline">
    <li
      *ngFor="let step of order.fulfillment?.timeline"
      class="fulfillment-step"
      [class.completed]="step.state === 'completed'"
      [class.current]="step.state === 'current'"
      [class.upcoming]="step.state === 'upcoming'"
      [class.cancelled]="step.state === 'cancelled'"
    >
      <button
        type="button"
        class="fulfillment-step-marker"
        [class.fulfillment-step-marker--clickable]="isTimelineStepClickable(step)"
        [disabled]="fulfillmentLoading || !isTimelineStepClickable(step)"
        [attr.aria-label]="getFulfillmentStageLabelKey(step.id) | translate"
        (click)="onTimelineStepClick(step)"
      >
        <mat-icon *ngIf="step.state === 'completed'">check</mat-icon>
        <mat-icon *ngIf="step.state === 'current'">radio_button_checked</mat-icon>
        <mat-icon *ngIf="step.state === 'cancelled'">close</mat-icon>
      </button>
      <div class="fulfillment-step-content">
        <div class="fulfillment-step-title">
          {{ getFulfillmentStageLabelKey(step.id) | translate }}
        </div>
        <div class="fulfillment-step-meta" *ngIf="step.occurredAt">
          {{ step.occurredAt | localizedDate : "medium" }}
        </div>
        <div class="fulfillment-step-actor" *ngIf="step.actor?.email">
          {{ step.actor?.name || step.actor?.email }}
          <span *ngIf="step.actor?.name" class="fulfillment-step-actor-email">
            {{ step.actor?.email }}
          </span>
        </div>
        <div class="fulfillment-step-detail" *ngIf="step.detail">{{ step.detail }}</div>
      </div>
    </li>
  </ol>
</section>

    </aside>

    <div class="detail-main">
  <section
  class="order-action-section card-panel"
  *ngIf="canMarkPickedFromPrinter"
>
  <div class="order-action-header">
    <div class="order-action-title">
      <h2>{{ "printCardOrders.fulfillment.pickedSectionTitle" | translate }}</h2>
      <p class="order-action-description">
        {{ "printCardOrders.fulfillment.pickedSectionBody" | translate }}
      </p>
    </div>
    <div class="order-action-status">
      <mat-icon class="status-icon idle">inventory_2</mat-icon>
    </div>
  </div>

  <div class="order-action-actions">
    <button
      mat-flat-button
      color="primary"
      (click)="advanceFulfillment('PICKED_FROM_PRINTER')"
      [disabled]="fulfillmentLoading"
    >
      <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="fulfillmentLoading"></mat-spinner>
      <mat-icon *ngIf="!fulfillmentLoading">inventory_2</mat-icon>
      {{ "printCardOrders.fulfillment.markPicked" | translate }}
    </button>
  </div>
</section>

<section
  class="order-action-section card-panel"
  *ngIf="canMarkPacked && !showUpsPackingSection"
>
  <div class="order-action-header">
    <div class="order-action-title">
      <h2>{{ "printCardOrders.fulfillment.confirmPackedTitle" | translate }}</h2>
      <p class="order-action-description">
        {{
          (isPickupDeliveryOrder
            ? "printCardOrders.fulfillment.confirmPackedPickupBody"
            : "printCardOrders.fulfillment.confirmPackedBody"
          ) | translate
        }}
      </p>
    </div>
    <div class="order-action-status">
      <mat-icon class="status-icon idle">inventory</mat-icon>
    </div>
  </div>

  <div class="order-action-actions">
    <button
      mat-flat-button
      color="primary"
      (click)="advanceFulfillment('PACKED')"
      [disabled]="fulfillmentLoading"
    >
      <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="fulfillmentLoading"></mat-spinner>
      <mat-icon *ngIf="!fulfillmentLoading">inventory</mat-icon>
      {{ "printCardOrders.fulfillment.markPacked" | translate }}
    </button>
  </div>
</section>

<section
  class="order-action-section card-panel"
  *ngIf="canMarkDelivered"
>
  <div class="order-action-header">
    <div class="order-action-title">
      <h2>{{
        (hasExternalShipment
          ? "printCardOrders.fulfillment.confirmExternalDeliveredTitle"
          : "printCardOrders.fulfillment.confirmDeliveredTitle"
        ) | translate
      }}</h2>
      <p class="order-action-description">
        {{
          (hasExternalShipment
            ? "printCardOrders.fulfillment.confirmExternalDeliveredBody"
            : "printCardOrders.fulfillment.confirmDeliveredBody"
          ) | translate
        }}
      </p>
    </div>
    <div class="order-action-status">
      <mat-icon class="status-icon idle">{{
        hasExternalShipment ? "local_shipping" : "handshake"
      }}</mat-icon>
    </div>
  </div>

  <div class="order-action-actions">
    <button
      mat-flat-button
      color="primary"
      (click)="advanceFulfillment('DELIVERED')"
      [disabled]="fulfillmentLoading"
    >
      <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="fulfillmentLoading"></mat-spinner>
      <mat-icon *ngIf="!fulfillmentLoading">done_all</mat-icon>
      {{ "printCardOrders.fulfillment.markDelivered" | translate }}
    </button>
  </div>
</section>

<section
  class="order-action-section card-panel"
  *ngIf="canForceSubmitToPrinter || showPrinterSubmitProgressPanel || isWaitingForOrderPdfs"
>
  <div class="order-action-header">
    <div class="order-action-title">
      <h2>{{ "printCardOrders.fulfillment.printerSubmitSectionTitle" | translate }}</h2>
      <p class="order-action-description" *ngIf="isWaitingForOrderPdfs && !isSubmittingToPrinter">
        {{ "printCardOrders.fulfillment.waitingForOrderPdfs" | translate }}
      </p>
      <p class="order-action-description" *ngIf="!isWaitingForOrderPdfs && (!isSubmittingToPrinter || canForceSubmitToPrinter)">
        {{
          printerSubmitSectionBodyKey
            | translate
              : {
                  groupId: printerOrderGroupId || "—",
                  referenceId: printerOrderReferenceId || "—"
                }
        }}
      </p>
      <p
        class="order-action-description"
        *ngIf="hasRegisteredPrinterGroup && (!isSubmittingToPrinter || canForceSubmitToPrinter)"
      >
        {{
          "printCardOrders.fulfillment.printerSubmitRegisteredMeta"
            | translate
              : {
                  groupId: printerOrderGroupId || "—",
                  referenceId: printerOrderReferenceId || "—"
                }
        }}
      </p>
      <p class="order-action-description" *ngIf="isSubmittingToPrinter">
        {{ printerSubmitPhaseLabelKey | translate }}
      </p>
    </div>
    <div
      class="order-action-status"
      [class.in-progress]="isSubmittingToPrinter || isWaitingForOrderPdfs"
    >
      <mat-icon
        *ngIf="isSubmittingToPrinter"
        class="status-icon in-progress"
      >sync</mat-icon>
      <mat-icon
        *ngIf="isWaitingForOrderPdfs && !isSubmittingToPrinter"
        class="status-icon in-progress"
      >sync</mat-icon>
      <mat-icon
        *ngIf="canForceSubmitToPrinter && !isSubmittingToPrinter"
        class="status-icon idle"
      >print</mat-icon>
    </div>
  </div>

  <div
    class="order-action-progress-block"
    *ngIf="showPrinterSubmitProgressPanel"
  >
    <div
      class="order-action-progress-meta"
      *ngIf="showOrderPdfArchiveCount"
    >
      <span class="order-action-progress-meta__count">
        {{
          "printCardOrders.fulfillment.waitingForOrderPdfsProgressCount"
            | translate
              : {
                  ready: displayedPrinterSubmitUploadedCount,
                  total: pdfArchiveTotalCount
                }
        }}
      </span>
      <span
        class="order-action-progress-meta__percent"
        *ngIf="printerSubmitProgressBarDeterminate"
      >{{ displayedPrinterSubmitPercent }}%</span>
    </div>
    <div
      class="order-action-progress-meta"
      *ngIf="!showOrderPdfArchiveCount && showPrinterSubmitCount && printerSubmitProgress as progress"
    >
      <span class="order-action-progress-meta__count">
        {{
          printerSubmitProgressCountKey
            | translate
              : {
                  uploaded: displayedPrinterSubmitUploadedCount,
                  total: progress.totalCount
                }
        }}
      </span>
      <span
        class="order-action-progress-meta__percent"
        *ngIf="printerSubmitProgressBarDeterminate"
      >{{ displayedPrinterSubmitPercent }}%</span>
    </div>
    <mat-progress-bar
      *ngIf="isSubmittingToPrinter || isWaitingForOrderPdfs || printerSubmitProgress?.phase === 'uploading'"
      [mode]="printerSubmitProgressBarDeterminate ? 'determinate' : 'indeterminate'"
      [value]="displayedPrinterSubmitPercent"
      class="order-action-progress"
      [class.order-action-progress--determinate]="printerSubmitProgressBarDeterminate"
    ></mat-progress-bar>
    <p
      class="order-action-current"
      *ngIf="printerSubmitDetailTranslateKey as detailKey"
    >
      {{ detailKey | translate : printerSubmitDetailParams }}
    </p>
    <p
      class="order-action-current order-action-current--live"
      *ngIf="printerSubmitProgress?.currentLabel as currentLabel"
    >
      {{ "printCardOrders.fulfillment.printerSubmitCurrent" | translate : { label: currentLabel } }}
    </p>
    <div
      class="order-action-uploaded"
      *ngIf="(printerSubmitProgress?.uploadedLabels?.length ?? 0) > 0"
    >
      <ul class="order-action-uploaded__list">
        <li
          *ngFor="let label of printerSubmitProgress?.uploadedLabels; trackBy: trackPrinterSubmitUploadedLabel"
        >{{ label }}</li>
      </ul>
    </div>
    <p class="order-action-error" *ngIf="printerSubmitErrorTranslateKey as errorKey">
      {{ errorKey | translate : printerSubmitErrorParams }}
    </p>
    <p
      class="order-action-error"
      *ngIf="
        !printerSubmitErrorTranslateKey &&
        printerSubmitProgress?.phase === 'failed' &&
        printerSubmitProgress?.lastError as lastError
      "
    >
      {{ lastError }}
    </p>
  </div>

  <div class="order-action-actions">
    <button
      mat-flat-button
      color="primary"
      *ngIf="isSubmittingToPrinter && !canForceSubmitToPrinter"
      disabled
    >
      <mat-spinner class="dc-btn-spinner" diameter="20"></mat-spinner>
      {{ printerSubmitPhaseLabelKey | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      *ngIf="isWaitingForOrderPdfs && !isSubmittingToPrinter"
      disabled
    >
      <mat-spinner class="dc-btn-spinner" diameter="20"></mat-spinner>
      {{ "printCardOrders.fulfillment.waitingForOrderPdfsAction" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      *ngIf="canForceSubmitToPrinter"
      (click)="forceSubmitToPrinter()"
      [disabled]="fulfillmentLoading"
    >
      <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="fulfillmentLoading"></mat-spinner>
      <mat-icon *ngIf="!fulfillmentLoading">print</mat-icon>
      {{
        (hasRegisteredPrinterGroup
          ? "printCardOrders.fulfillment.forceSubmitResumeConfirm"
          : "printCardOrders.fulfillment.forceSubmitConfirm"
        ) | translate
      }}
    </button>
  </div>
</section>

<section
  class="order-action-section card-panel"
  *ngIf="isMergedOrder"
>
  <div class="order-action-header">
    <div class="order-action-title">
      <h2>{{ "printCardOrders.merge.mergedSectionTitle" | translate }}</h2>
      <p class="order-action-description">
        {{
          "printCardOrders.merge.mergedSectionBody"
            | translate : { count: mergedSourceCount }
        }}
      </p>
    </div>
    <div class="order-action-status">
      <mat-icon class="status-icon idle">call_merge</mat-icon>
    </div>
  </div>

  <div class="order-action-actions" *ngIf="canUnmergeOrder">
    <button
      mat-stroked-button
      color="warn"
      (click)="unmergeOrder()"
      [disabled]="unmergeLoading || fulfillmentLoading"
    >
      <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="unmergeLoading"></mat-spinner>
      <mat-icon *ngIf="!unmergeLoading">undo</mat-icon>
      {{ "printCardOrders.merge.unmerge" | translate }}
    </button>
  </div>
  <p class="order-action-description" *ngIf="showUnmergeBlockedByCarrier">
    {{ "printCardOrders.merge.unmergeBlockedCarrier" | translate }}
  </p>
</section>

  <section class="info-section card-panel">
    <h2>{{ "printCardOrders.orderInfo" | translate }}</h2>
    <div class="info-grid">
      <div>
        <span class="label">{{ "printCardOrders.orderId" | translate }}</span>
        <span>{{ order.printCardOrderId }}</span>
      </div>
      <div>
        <span class="label">{{ "domain" | translate }}</span>
        <span>{{ order.domain }}</span>
      </div>
      <div>
        <span class="label">{{ "printCardOrders.employee" | translate }}</span>
        <span *ngIf="order.recipients?.length <= 1">{{ order.employeeName || order.employeeEmail }}</span>
        <span *ngIf="order.recipients?.length > 1">
          {{ "printCardOrders.groupRecipientsCount" | translate : { count: order.recipients.length } }}
        </span>
      </div>
      <div>
        <span class="label">{{ "cardOrders.placedBy" | translate }}</span>
        <span>{{ order.placedByName || order.placedByEmail }}</span>
      </div>
      <div>
        <span class="label">{{ "printCardOrders.createdAt" | translate }}</span>
        <span>{{ order.createdAt | localizedDate : "medium" }}</span>
      </div>
      <div *ngIf="order.printer?.endDate">
        <span class="label">{{ "printCardOrders.printerEndDate" | translate }}</span>
        <span>{{ order.printer?.endDate }}</span>
      </div>
      <div *ngIf="scheduledPrinterSubmitAt">
        <span class="label">{{ "printCardOrders.scheduledPrinterSubmitAt" | translate }}</span>
        <span>{{ scheduledPrinterSubmitAt | localizedDate : "medium" }}</span>
      </div>
      <div *ngIf="order.deliveryType">
        <span class="label">{{ "printCardOrders.deliveryType" | translate }}</span>
        <span>{{ getShipmentMethodLabelKey(order.deliveryType) | translate }}</span>
      </div>
      <div *ngIf="order.deliverySpeed">
        <span class="label">{{ "printCardOrders.deliverySpeed" | translate }}</span>
        <span>{{ getDeliverySpeedLabelKey(order.deliverySpeed) | translate }}</span>
      </div>
      <div *ngIf="order.productionTime">
        <span class="label">{{ "printCardOrders.productionTime" | translate }}</span>
        <span>{{ getProductionTimeLabelKey(order.productionTime) | translate }}</span>
      </div>
      <div *ngIf="order.deliveryType !== 'PICKUP' && order.shipmentCarrier">
        <span class="label">{{ "printCardOrders.shipmentCarrier" | translate }}</span>
        <span *ngIf="order.shipmentCarrier !== 'OTHER'">{{
          getShipmentCarrierLabelKey(order.shipmentCarrier) | translate
        }}</span>
        <span *ngIf="order.shipmentCarrier === 'OTHER'">{{
          order.externalShipment?.carrierName ||
            ("printCardOrders.shipmentCarrierOther" | translate)
        }}</span>
      </div>
      <div *ngIf="order.recipientName">
        <span class="label">{{ "printCardOrders.recipientName" | translate }}</span>
        <span>{{ order.recipientName }}</span>
      </div>
      <div *ngIf="order.companyName">
        <span class="label">{{ "printCardOrders.companyName" | translate }}</span>
        <span>{{ order.companyName }}</span>
      </div>
      <div *ngIf="order.phone">
        <span class="label">{{ "printCardOrders.phone" | translate }}</span>
        <span>{{ order.phone }}</span>
      </div>
      <div
        *ngIf="order.deliveryType !== 'PICKUP' && order.shippingAddress?.line1"
        class="full-width-info"
      >
        <span class="label">{{ "printCardOrders.shippingAddress" | translate }}</span>
        <span class="address-lines">
          <span
            class="address-line"
            *ngFor="let line of formatShippingAddressLines(order.shippingAddress)"
          >
            {{ line }}
          </span>
          <span
            class="country-address-label address-country"
            *ngIf="order.shippingAddress.country?.trim() as countryCode"
          >
            <img
              class="country-select-flag"
              [src]="getCountryFlagUrl(countryCode)"
              width="20"
              height="15"
              alt=""
            />
            {{ getCountryDisplayName(countryCode) }}
          </span>
        </span>
      </div>
      <div
        *ngIf="order.deliveryType === 'ACCESS_POINT' && order.upsAccessPoint as accessPoint"
        class="full-width-info"
      >
        <span class="label">{{ "printCardOrders.accessPoint" | translate }}</span>
        <span class="access-point-detail">
          <span>
            {{ formatUpsAccessPointName(accessPoint.name) }},
            {{ formatUpsAccessPointAddress(accessPoint) }}
          </span>
          <span
            class="access-point-detail__hours"
            *ngIf="formatUpsAccessPointOpeningHours(accessPoint.openingHours) as openingHours"
          >
            <span class="access-point-detail__hours-label">
              {{ "cardOrders.accessPointOpeningHoursLabel" | translate }}
            </span>
            {{ openingHours }}
          </span>
        </span>
      </div>
      <div *ngIf="order.notes?.trim()" class="full-width-info">
        <span class="label">{{ "printCardOrders.orderNotes" | translate }}</span>
        <span class="order-notes-text">{{ order.notes }}</span>
      </div>
      <div *ngIf="hasUpsTracking && order.shipper as shipper" class="full-width-info">
        <span class="label">{{ "printCardOrders.shipper" | translate }}</span>
        <span class="address-lines">
          <span class="address-line">{{ shipper.name }}</span>
          <span
            class="address-line"
            *ngFor="let line of formatShippingAddressLines(shipper)"
          >
            {{ line }}
          </span>
          <span
            class="country-address-label address-country"
            *ngIf="shipper.country?.trim() as countryCode"
          >
            <img
              class="country-select-flag"
              [src]="getCountryFlagUrl(countryCode)"
              width="20"
              height="15"
              alt=""
            />
            {{ getCountryDisplayName(countryCode) }}
          </span>
          <span class="address-line">{{ shipper.phone }}</span>
        </span>
      </div>
    </div>

    <h3>{{ "printCardOrders.items" | translate }}</h3>
    <app-order-items-list
      *ngIf="order.recipients?.length"
      [recipients]="order.recipients"
      [showPrinterDetails]="true"
      [showPreviewActions]="true"
      [showNameLabelActions]="true"
      [nameLabelLoading]="nameLabelLoading"
      [orderId]="order.printCardOrderId"
      previewApi="admin"
      (nameLabelPrint)="printNameLabel($event.employeeEmail)"
    ></app-order-items-list>
  </section>

  <section class="fulfillment-section card-panel" *ngIf="hasExternalShipment && order.externalShipment">
    <h3>{{ "printCardOrders.externalShipmentTitle" | translate }}</h3>
    <div class="info-grid">
      <div>
        <span class="label">{{ "printCardOrders.shipmentCarrier" | translate }}</span>
        <span>{{ order.externalShipment.carrierName }}</span>
      </div>
      <div>
        <span class="label">{{ "printCardOrders.trackingNumber" | translate }}</span>
        <span>{{ order.externalShipment.trackingNumber }}</span>
      </div>
      <div *ngIf="order.externalShipment.trackingUrl">
        <span class="label">{{ "printCardOrders.externalShipmentTrackingLink" | translate }}</span>
        <a
          [href]="order.externalShipment.trackingUrl"
          target="_blank"
          rel="noopener noreferrer"
          >{{ order.externalShipment.trackingUrl }}</a
        >
      </div>
    </div>
  </section>

  <section class="fulfillment-section card-panel" *ngIf="hasUpsTracking && !hasExternalShipment">
    <app-ups-packages-tracking
      *ngIf="orderUpsPackages.length"
      [packages]="orderUpsPackages"
      [shipmentDescription]="orderUpsShipmentDescription"
      [shipmentCarrier]="order.shipmentCarrier"
    ></app-ups-packages-tracking>

    <app-ups-tracking-timeline
      *ngIf="!orderUpsPackages.length"
      [trackingNumber]="upsTrackingNumber"
      [status]="upsTrackingStatus"
      [activities]="trackingDetails?.activities ?? []"
      [delivered]="isUpsDelivered"
      [shipmentDescription]="orderUpsShipmentDescription"
      [shipmentCarrier]="order.shipmentCarrier"
      [collapsibleHistory]="true"
    ></app-ups-tracking-timeline>

    <div class="ups-pickup-summary" *ngIf="showUpsPickupSection">
      <h3>{{ "printCardOrders.shipment.sectionPickup" | translate }}</h3>
      <ng-container *ngIf="hasActiveUpsPickup && upsPickup">
        <p>
          <strong>{{ "printCardOrders.shipment.pickupPrn" | translate }}:</strong>
          {{ upsPickup.prn }}
        </p>
        <p *ngIf="upsPickup.status">
          <strong>{{ "printCardOrders.shipment.pickupStatus" | translate }}:</strong>
          {{ upsPickup.status }}
        </p>
        <p *ngIf="upsPickup.pickupDate">
          <strong>{{ "printCardOrders.shipment.pickupDate" | translate }}:</strong>
          <ng-container
            *ngIf="parseUpsPickupDate(upsPickup.pickupDate) as pickupDate; else rawActivePickupDate"
          >
            {{ pickupDate | localizedDate : "mediumDate" }}
          </ng-container>
          <ng-template #rawActivePickupDate>{{ upsPickup.pickupDate }}</ng-template>
          <ng-container
            *ngIf="formatUpsPickupTime(upsPickup.readyTime) as readyTime"
          >
            · {{ readyTime
            }}<ng-container
              *ngIf="formatUpsPickupTime(upsPickup.closeTime) as closeTime"
              >-{{ closeTime }}</ng-container
            >
          </ng-container>
        </p>
      </ng-container>
      <p *ngIf="canScheduleUpsPickup">
        {{ "printCardOrders.shipment.pickupMissing" | translate }}
      </p>
      <form
        [formGroup]="pickupScheduleForm"
        class="form-grid party-form-grid"
        *ngIf="canScheduleUpsPickup"
      >
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.pickupDate" | translate }}</mat-label>
          <input
            matInput
            [matDatepicker]="postShipPickupDatePicker"
            formControlName="pickupDate"
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-datepicker-toggle matIconSuffix [for]="postShipPickupDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #postShipPickupDatePicker></mat-datepicker>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: pickupScheduleForm, field: 'pickupDate' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.readyTime" | translate }}</mat-label>
          <input
            matInput
            [matTimepicker]="postShipReadyTimePicker"
            formControlName="readyTime"
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-timepicker-toggle matIconSuffix [for]="postShipReadyTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #postShipReadyTimePicker interval="15m"></mat-timepicker>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: pickupScheduleForm, field: 'readyTime' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.closeTime" | translate }}</mat-label>
          <input
            matInput
            [matTimepicker]="postShipCloseTimePicker"
            formControlName="closeTime"
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-timepicker-toggle matIconSuffix [for]="postShipCloseTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #postShipCloseTimePicker interval="15m"></mat-timepicker>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: pickupScheduleForm, field: 'closeTime' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.pickupPoint" | translate }}</mat-label>
          <input matInput formControlName="pickupPoint" maxlength="11" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
          <mat-label>{{ "printCardOrders.shipment.specialInstruction" | translate }}</mat-label>
          <input matInput formControlName="specialInstruction" maxlength="57" />
        </mat-form-field>
      </form>
      <div class="actions-buttons" *ngIf="canScheduleUpsPickup || canCancelUpsPickup">
        <button
          mat-stroked-button
          type="button"
          *ngIf="canScheduleUpsPickup"
          (click)="scheduleUpsPickup()"
          [disabled]="shipping"
        >
          {{ "printCardOrders.shipment.pickupSchedule" | translate }}
        </button>
        <button
          mat-stroked-button
          type="button"
          color="warn"
          *ngIf="canCancelUpsPickup"
          (click)="cancelUpsPickup()"
          [disabled]="shipping"
        >
          {{ "printCardOrders.shipment.pickupCancelConfirm" | translate }}
        </button>
      </div>
    </div>

    <div class="actions-buttons" *ngIf="canVoidUpsShipment">
      <button
        mat-stroked-button
        type="button"
        color="warn"
        (click)="voidUpsShipment()"
        [disabled]="shipping"
      >
        <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="shipping"></mat-spinner>
        {{ "printCardOrders.shipment.voidConfirm" | translate }}
      </button>
    </div>
  </section>

  <section
    class="parties-section card-panel"
    *ngIf="!hasUpsTracking && order.status !== 'DELIVERED'"
  >
    <div class="parties-header">
      <h2>{{ "printCardOrders.shipmentParties" | translate }}</h2>
      <button
        mat-stroked-button
        type="button"
        *ngIf="canEstimateUpsShippingCost"
        (click)="openUpsShopRatesDialog()"
        [disabled]="shipping || loadingPackPlan"
      >
        {{ "printCardOrders.shopRates.estimateButton" | translate }}
      </button>
    </div>

    <div class="form-card parties-delivery-type" [formGroup]="recipientForm">
      <h3>{{ "printCardOrders.deliveryType" | translate }}</h3>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="parties-delivery-type__field">
        <mat-select formControlName="deliveryType" required>
          <mat-option value="COURIER">
            {{ "printCardOrders.deliveryTypeCourier" | translate }}
          </mat-option>
          <mat-option value="ACCESS_POINT">
            {{ "printCardOrders.deliveryTypeAccessPoint" | translate }}
          </mat-option>
          <mat-option value="PICKUP">
            {{ "printCardOrders.deliveryTypePickup" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="parties-row">
      <form
        [formGroup]="shipperForm"
        class="form-card party-card"
        *ngIf="order.deliveryType !== 'PICKUP'"
      >
        <h3>{{ "printCardOrders.shipper" | translate }}</h3>
        <div class="form-grid party-form-grid">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.shipperName" | translate }}</mat-label>
            <input
              matInput
              [errorStateMatcher]="partiesErrorStateMatcher"
              formControlName="name"
              required
              [readonly]="hasUpsTracking"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: shipperForm, field: 'name' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.addressLine1" | translate }}</mat-label>
            <input
              matInput
              [errorStateMatcher]="partiesErrorStateMatcher"
              formControlName="line1"
              required
              [readonly]="hasUpsTracking"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: shipperForm, field: 'line1' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.addressLine2" | translate }}</mat-label>
            <input matInput formControlName="line2" [readonly]="hasUpsTracking" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.city" | translate }}</mat-label>
            <input
              matInput
              [errorStateMatcher]="partiesErrorStateMatcher"
              formControlName="city"
              required
              [readonly]="hasUpsTracking"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: shipperForm, field: 'city' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.postalCode" | translate }}</mat-label>
            <input
              matInput
              [errorStateMatcher]="partiesErrorStateMatcher"
              formControlName="postalCode"
              required
              [readonly]="hasUpsTracking"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: shipperForm, field: 'postalCode' }"></ng-container>
          </mat-form-field>
          <app-country-select
            formControlName="country"
            [label]="'printCardOrders.country' | translate"
            [errorStateMatcher]="partiesErrorStateMatcher"
            [required]="true"
            [disabled]="hasUpsTracking"
          ></app-country-select>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.phone" | translate }}</mat-label>
            <input
              matInput
              [errorStateMatcher]="partiesErrorStateMatcher"
              formControlName="phone"
              required
              [readonly]="hasUpsTracking"
            />
            <ng-container *ngTemplateOutlet="phoneErrors; context: { form: shipperForm, field: 'phone' }"></ng-container>
          </mat-form-field>
        </div>
      </form>

      <form [formGroup]="recipientForm" class="recipient-column">
        <div class="form-card party-card">
          <h3>{{ "printCardOrders.recipient" | translate }}</h3>
          <div class="form-grid party-form-grid">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
              <mat-label>{{ "printCardOrders.recipientName" | translate }}</mat-label>
              <input
                matInput
                [errorStateMatcher]="partiesErrorStateMatcher"
                formControlName="recipientName"
                required
                [readonly]="hasUpsTracking"
              />
              <ng-container *ngTemplateOutlet="requiredError; context: { form: recipientForm, field: 'recipientName' }"></ng-container>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
              <mat-label>{{ "printCardOrders.companyName" | translate }}</mat-label>
              <input
                matInput
                formControlName="companyName"
                maxlength="200"
                [readonly]="hasUpsTracking"
              />
            </mat-form-field>
            <ng-container *ngIf="order.deliveryType !== 'PICKUP'">
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
                <mat-label>{{ "printCardOrders.addressLine1" | translate }}</mat-label>
                <input
                  matInput
                  [errorStateMatcher]="partiesErrorStateMatcher"
                  formControlName="line1"
                  required
                  [readonly]="hasUpsTracking"
                />
                <ng-container *ngTemplateOutlet="requiredError; context: { form: recipientForm, field: 'line1' }"></ng-container>
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
                <mat-label>{{ "printCardOrders.addressLine2" | translate }}</mat-label>
                <input matInput formControlName="line2" [readonly]="hasUpsTracking" />
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "printCardOrders.city" | translate }}</mat-label>
                <input
                  matInput
                  [errorStateMatcher]="partiesErrorStateMatcher"
                  formControlName="city"
                  required
                  [readonly]="hasUpsTracking"
                />
                <ng-container *ngTemplateOutlet="requiredError; context: { form: recipientForm, field: 'city' }"></ng-container>
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "printCardOrders.postalCode" | translate }}</mat-label>
                <input
                  matInput
                  [errorStateMatcher]="partiesErrorStateMatcher"
                  formControlName="postalCode"
                  required
                  [readonly]="hasUpsTracking"
                />
                <ng-container *ngTemplateOutlet="requiredError; context: { form: recipientForm, field: 'postalCode' }"></ng-container>
              </mat-form-field>
              <app-country-select
                formControlName="country"
                [label]="'printCardOrders.country' | translate"
                [errorStateMatcher]="partiesErrorStateMatcher"
                [required]="true"
                [disabled]="hasUpsTracking"
              ></app-country-select>
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
                <mat-label>
                  <span class="label-with-help">
                    <span>{{ "printCardOrders.shipment.addressLocationType" | translate }}</span>
                    <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'addressLocationType' }"></ng-container>
                  </span>
                </mat-label>
                <mat-select
                  formControlName="addressLocationType"
                  required
                  [errorStateMatcher]="partiesErrorStateMatcher"
                  [disabled]="hasUpsTracking"
                >
                  <mat-option *ngFor="let option of upsOptions?.addressLocationTypes ?? []" [value]="option.code">
                    {{ option.labelKey | translate }}
                  </mat-option>
                </mat-select>
                <ng-container *ngTemplateOutlet="requiredError; context: { form: recipientForm, field: 'addressLocationType' }"></ng-container>
              </mat-form-field>
            </ng-container>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
              <mat-label>{{ "printCardOrders.phone" | translate }}</mat-label>
              <input
                matInput
                [errorStateMatcher]="partiesErrorStateMatcher"
                formControlName="phone"
                required
                [readonly]="hasUpsTracking"
              />
              <ng-container *ngTemplateOutlet="phoneErrors; context: { form: recipientForm, field: 'phone' }"></ng-container>
            </mat-form-field>
          </div>

          <section class="access-point-section" *ngIf="isAccessPointDelivery" [class.access-point-section--invalid]="errorStateMatcher.submitAttempted && recipientForm.get('accessPointId')?.invalid">
            <div class="access-point-section__header">
              <h4>{{ "printCardOrders.accessPoint" | translate }}</h4>
              <button
                mat-stroked-button
                type="button"
                *ngIf="!hasUpsTracking"
                (click)="openAccessPointPicker()"
              >
                {{
                  (hasSelectedAccessPoint
                    ? "printCardOrders.changeAccessPoint"
                    : "printCardOrders.selectAccessPoint") | translate
                }}
              </button>
            </div>

            <div
              class="selected-access-point"
              *ngIf="selectedAccessPointView as accessPoint"
            >
              <strong>{{ accessPoint.name }}</strong>
              <span>{{ accessPoint.address }}</span>
              <span class="selected-access-point__hours" *ngIf="accessPoint.openingHours">
                <span class="selected-access-point__hours-label">
                  {{ "cardOrders.accessPointOpeningHoursLabel" | translate }}
                </span>
                {{ accessPoint.openingHours }}
              </span>
            </div>
          </section>
        </div>
      </form>
    </div>

    <div class="parties-actions">
      <button
        mat-flat-button
        type="button"
        class="parties-save-button"
        [class.parties-save-button--active]="shipmentPartiesDirty"
        [color]="shipmentPartiesDirty ? 'primary' : undefined"
        (click)="saveShipmentParties()"
        [disabled]="!shipmentPartiesDirty || savingParties || hasUpsTracking"
      >
        <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="savingParties"></mat-spinner>
        {{ "printCardOrders.saveShipmentParties" | translate }}
      </button>
    </div>
  </section>

  
  <section class="form-section card-panel" *ngIf="showNfcEncodingSection">
  <div class="ups-section-header">
    <h2>{{ "printCardOrders.nfcEncoding.title" | translate }}</h2>
  </div>
  <p class="nfc-encoding-hint">
    {{ "printCardOrders.nfcEncoding.description" | translate }}
  </p>
  <p class="nfc-encoding-trial-hint" *ngIf="canMarkNfcEncodedManually">
    {{ "printCardOrders.nfcEncoding.trialHint" | translate }}
  </p>
  <p class="nfc-encoding-warning" *ngIf="pendingNfcEncodingCount > 0">
    {{
      "printCardOrders.nfcEncoding.pendingWarning"
        | translate: { count: pendingNfcEncodingCount }
    }}
  </p>
  <ul class="nfc-encoding-list">
    <li
      class="nfc-encoding-item"
      [class.nfc-encoding-item--done]="item.encoded"
      [class.nfc-encoding-item--partial]="item.inProgress"
      *ngFor="let item of nfcEncodingItems; trackBy: trackNfcEncodingItem"
    >
      <mat-checkbox
        *ngIf="canMarkNfcEncodedManually"
        class="nfc-encoding-item__check"
        color="primary"
        [checked]="item.encoded"
        [disabled]="item.encoded || nfcEncodingLoading"
        [matTooltip]="
          item.encoded
            ? ('printCardOrders.nfcEncoding.encoded' | translate)
            : ('printCardOrders.nfcEncoding.markEncoded' | translate)
        "
        (change)="onNfcEncodedCheckboxChange(item, $event.checked)"
      ></mat-checkbox>
      <div class="nfc-encoding-item__main">
        <div class="nfc-encoding-item__header">
          <span class="nfc-encoding-item__order">{{ item.printerOrderNumber }}</span>
          <span
            class="nfc-encoding-item__status"
            [class.nfc-encoding-item__status--done]="item.encoded"
            [class.nfc-encoding-item__status--partial]="item.inProgress"
          >
            {{
              item.encoded
                ? ("printCardOrders.nfcEncoding.encoded" | translate)
                : item.inProgress
                  ? ("printCardOrders.nfcEncoding.encodedProgress"
                    | translate
                      : { done: item.encodedCount, total: item.quantity })
                  : ("printCardOrders.nfcEncoding.notEncoded" | translate)
            }}
          </span>
        </div>
        <p class="nfc-encoding-item__recipient">{{ item.employeeName }}</p>
        <p class="nfc-encoding-item__details">
          <span class="nfc-encoding-item__type">{{
            getTemplateTypeLabelKey(item.templateType) | translate
          }}</span>
          <span class="nfc-encoding-item__separator">·</span>
          <span
            >{{ item.quantity }}
            {{ "printCardOrders.quantityUnit" | translate }}</span
          >
        </p>
      </div>
      <button
        mat-icon-button
        type="button"
        class="nfc-encoding-item__preview"
        (click)="openNfcItemPreview(item)"
        [attr.aria-label]="'printCardOrders.previewItem' | translate"
        [matTooltip]="'printCardOrders.previewItem' | translate"
      >
        <mat-icon>visibility</mat-icon>
      </button>
    </li>
  </ul>
</section>


  <section class="form-section card-panel" *ngIf="showUpsPackingSection">
    <div class="ups-section-header">
      <div class="ups-section-heading">
        <h2>{{ "printCardOrders.shipmentPackages.sectionTitle" | translate }}</h2>
      </div>
      <div class="ups-section-actions">
        <button
          mat-stroked-button
          type="button"
          *ngIf="upsPackingLocked"
          (click)="startUpsPackingEdit()"
          [disabled]="savingUpsPacking || shipping || fulfillmentLoading"
        >
          {{ "printCardOrders.shipmentPackages.editPacking" | translate }}
        </button>
        <button
          mat-stroked-button
          type="button"
          *ngIf="upsPackingEditing"
          (click)="cancelUpsPackingEdit()"
          [disabled]="savingUpsPacking || shipping || fulfillmentLoading"
        >
          {{ "printCardOrders.shipmentPackages.cancelPackingEdit" | translate }}
        </button>
      </div>
    </div>

    <div class="inline-loading pack-plan-loading" *ngIf="loadingPackPlan">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <app-ups-package-planner
      *ngIf="!loadingPackPlan"
      [lineItems]="upsPackLineItems"
      [packages]="upsPackages"
      [upsOptions]="upsOptions"
      [disabled]="upsPlannerDisabled || shipping"
      [packerName]="packerName"
      (packagesChange)="onUpsPackagesChange($event)"
      (autoArrange)="autoArrangeUpsPackages()"
      (previewItem)="openPackLinePreview($event)"
    ></app-ups-package-planner>

    <div class="parties-actions" *ngIf="canMarkPacked || upsPackingEditing">
      <button
        mat-stroked-button
        type="button"
        *ngIf="canMarkPacked || upsPackingEditing"
        (click)="saveUpsPackingEdit()"
        [disabled]="savingUpsPacking || shipping || fulfillmentLoading || loadingPackPlan"
      >
        <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="savingUpsPacking"></mat-spinner>
        {{ "printCardOrders.shipmentPackages.savePacking" | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        *ngIf="canMarkPacked"
        (click)="markPackedWithUps()"
        [disabled]="fulfillmentLoading || shipping || hasUpsTracking || savingUpsPacking || loadingPackPlan"
      >
        <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="fulfillmentLoading"></mat-spinner>
        {{ "printCardOrders.fulfillment.markPacked" | translate }}
      </button>
    </div>
  </section>

  <section class="form-section card-panel" *ngIf="showUpsPackingSection">
    <div class="ups-section-header">
      <h2>{{ "printCardOrders.shipmentDetails" | translate }}</h2>
    </div>

    <div class="ups-forms-layout">
    <form [formGroup]="shipmentForm" class="form-card party-card ups-form-card" *ngIf="upsOptions">
      <h3>{{ "printCardOrders.shipment.sectionDelivery" | translate }}</h3>
      <div class="form-grid party-form-grid">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
          <mat-label>
            <span class="label-with-help">
              <span>{{ "printCardOrders.shipment.serviceCode" | translate }}</span>
              <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'serviceCode' }"></ng-container>
            </span>
          </mat-label>
          <mat-select formControlName="serviceCode" required [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let option of availableUpsServices" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'serviceCode' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
          <mat-label>
            <span class="label-with-help">
              <span>{{ "printCardOrders.shipment.packagingCode" | translate }}</span>
              <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'packagingCode' }"></ng-container>
            </span>
          </mat-label>
          <mat-select formControlName="packagingCode" required [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let option of upsOptions.packagingCodes" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'packagingCode' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
          <mat-label>
            <span class="label-with-help">
              <span>{{ "printCardOrders.shipment.ratingRequestOption" | translate }}</span>
              <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'ratingRequestOption' }"></ng-container>
            </span>
          </mat-label>
          <mat-select formControlName="ratingRequestOption" required [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let option of upsOptions.ratingRequestOptions" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'ratingRequestOption' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full" *ngIf="isAccessPointDelivery">
          <mat-label>
            <span class="label-with-help">
              <span>{{ "printCardOrders.shipment.shipmentIndicationLabel" | translate }}</span>
              <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'shipmentIndication' }"></ng-container>
            </span>
          </mat-label>
          <mat-select formControlName="shipmentIndicationCode" required [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let option of upsOptions.shipmentIndicationTypes" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'shipmentIndicationCode' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full" *ngIf="!isAccessPointDelivery">
          <mat-label>
            <span class="label-with-help">
              <span>{{ "printCardOrders.shipment.deliveryConfirmationLabel" | translate }}</span>
              <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'deliveryConfirmation' }"></ng-container>
            </span>
          </mat-label>
          <mat-select formControlName="deliveryConfirmation">
            <mat-option *ngFor="let option of upsOptions.deliveryConfirmationTypes" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-grid party-form-grid">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.weightUnitLabel" | translate }}</mat-label>
          <mat-select formControlName="weightUnit" required [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let option of upsOptions.weightUnits" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'weightUnit' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.dimensionUnitLabel" | translate }}</mat-label>
          <mat-select formControlName="dimensionUnit" required [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let option of upsOptions.dimensionUnits" [value]="option.code">
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'dimensionUnit' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
          <mat-label>{{ "printCardOrders.shipment.shipmentDescription" | translate }}</mat-label>
          <input matInput formControlName="shipmentDescription" maxlength="50" />
        </mat-form-field>
      </div>

      <h4 class="subsection-title">{{ "printCardOrders.shipment.sectionPickup" | translate }}</h4>
      <div class="checkbox-grid">
        <mat-checkbox formControlName="pickupEnabled">
          {{ "printCardOrders.shipment.pickupEnabled" | translate }}
        </mat-checkbox>
      </div>
      <div class="form-grid party-form-grid" *ngIf="shipmentForm.get('pickupEnabled')?.value">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.pickupDate" | translate }}</mat-label>
          <input
            matInput
            [matDatepicker]="shipPickupDatePicker"
            formControlName="pickupDate"
            required
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-datepicker-toggle matIconSuffix [for]="shipPickupDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #shipPickupDatePicker></mat-datepicker>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'pickupDate' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.readyTime" | translate }}</mat-label>
          <input
            matInput
            [matTimepicker]="shipReadyTimePicker"
            formControlName="readyTime"
            required
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-timepicker-toggle matIconSuffix [for]="shipReadyTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #shipReadyTimePicker interval="15m"></mat-timepicker>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'readyTime' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.closeTime" | translate }}</mat-label>
          <input
            matInput
            [matTimepicker]="shipCloseTimePicker"
            formControlName="closeTime"
            required
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-timepicker-toggle matIconSuffix [for]="shipCloseTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #shipCloseTimePicker interval="15m"></mat-timepicker>
          <ng-container *ngTemplateOutlet="requiredError; context: { form: shipmentForm, field: 'closeTime' }"></ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "printCardOrders.shipment.pickupPoint" | translate }}</mat-label>
          <input matInput formControlName="pickupPoint" maxlength="11" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
          <mat-label>{{ "printCardOrders.shipment.specialInstruction" | translate }}</mat-label>
          <input matInput formControlName="specialInstruction" maxlength="57" />
        </mat-form-field>
      </div>
    </form>

    <form [formGroup]="shipmentAccessorialsForm!" class="form-card party-card ups-form-card" *ngIf="shipmentAccessorialsForm && upsOptions">
      <h3>{{ "printCardOrders.shipment.sectionAccessorials" | translate }}</h3>
      <div class="checkbox-grid">
        <div class="checkbox-with-help" *ngFor="let option of upsOptions.shipmentAccessorials">
          <mat-checkbox [formControlName]="option.code">
            {{ option.labelKey | translate }}
          </mat-checkbox>
          <mat-icon
            class="field-help"
            [matTooltip]="
              (accessorialDisabledReasonKey(option.code) ||
                ('printCardOrders.shipment.hint.accessorial.' + option.code)) | translate
            "
            matTooltipPosition="above"
            [attr.aria-label]="
              (accessorialDisabledReasonKey(option.code) ||
                ('printCardOrders.shipment.hint.accessorial.' + option.code)) | translate
            "
          >help_outline</mat-icon>
        </div>
      </div>
    </form>

    <form [formGroup]="notificationForm" class="form-card party-card ups-form-card ups-form-card--wide notifications-card" *ngIf="upsOptions">
      <h3>{{ "printCardOrders.shipment.sectionNotification" | translate }}</h3>

      <div class="notification-block" *ngIf="!isAccessPointDelivery">
        <div class="notification-block__header">
          <span class="notification-block__title">{{ "printCardOrders.shipment.sectionQvnNotification" | translate }}</span>
          <mat-icon
            class="field-help"
            [matTooltip]="'printCardOrders.shipment.hint.sectionQvnNotification' | translate"
            matTooltipPosition="above"
            [attr.aria-label]="'printCardOrders.shipment.hint.sectionQvnNotification' | translate"
          >help_outline</mat-icon>
        </div>
        <mat-checkbox formControlName="qvnEmailEnabled">
          {{ "printCardOrders.shipment.notificationEmailEnabled" | translate }}
        </mat-checkbox>
        <div class="notification-fields" *ngIf="notificationForm.get('qvnEmailEnabled')?.value">
          <div class="form-grid party-form-grid">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.shipment.notificationCode" | translate }}</mat-label>
              <mat-select formControlName="qvnEmailNotificationCode" required [errorStateMatcher]="errorStateMatcher">
                <mat-option *ngFor="let option of upsOptions.emailNotificationCodes" [value]="option.code">
                  {{ option.labelKey | translate }}
                </mat-option>
              </mat-select>
              <ng-container *ngTemplateOutlet="requiredError; context: { form: notificationForm, field: 'qvnEmailNotificationCode' }"></ng-container>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.shipment.notificationEmail" | translate }}</mat-label>
              <input matInput formControlName="qvnEmail" type="email" required [errorStateMatcher]="errorStateMatcher" />
              <ng-container *ngTemplateOutlet="emailErrors; context: { form: notificationForm, field: 'qvnEmail' }"></ng-container>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="notification-block" *ngIf="isAccessPointDelivery">
        <div class="notification-block__header">
          <span class="notification-block__title">{{ "printCardOrders.shipment.sectionAccessPointNotifications" | translate }}</span>
          <mat-icon
            class="field-help"
            [matTooltip]="'printCardOrders.shipment.hint.sectionAccessPointNotifications' | translate"
            matTooltipPosition="above"
            [attr.aria-label]="'printCardOrders.shipment.hint.sectionAccessPointNotifications' | translate"
          >help_outline</mat-icon>
        </div>

        <div class="notification-panel party-card">
          <div class="notification-panel__header">
            <span class="notification-panel__title">{{ "printCardOrders.shipment.adlNotificationTitle" | translate }}</span>
            <mat-icon
              class="field-help"
              [matTooltip]="'printCardOrders.shipment.hint.adlNotification' | translate"
              matTooltipPosition="above"
              [attr.aria-label]="'printCardOrders.shipment.hint.adlNotification' | translate"
            >help_outline</mat-icon>
          </div>
          <div class="form-grid party-form-grid">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.shipment.notificationChannelLabel" | translate }}</mat-label>
              <mat-select formControlName="adlChannel" required [errorStateMatcher]="errorStateMatcher">
                <mat-option *ngFor="let option of upsOptions.notificationChannels" [value]="option.code">
                  {{ option.labelKey | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="notificationForm.get('adlChannel')?.value === 'email'">
              <mat-label>{{ "printCardOrders.shipment.notificationEmail" | translate }}</mat-label>
              <input matInput formControlName="adlEmail" type="email" required [errorStateMatcher]="errorStateMatcher" />
              <ng-container *ngTemplateOutlet="emailErrors; context: { form: notificationForm, field: 'adlEmail' }"></ng-container>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="notificationForm.get('adlChannel')?.value !== 'email'">
              <mat-label>{{ "printCardOrders.shipment.notificationPhone" | translate }}</mat-label>
              <input matInput formControlName="adlPhone" type="tel" required [errorStateMatcher]="errorStateMatcher" />
              <ng-container *ngTemplateOutlet="phoneErrors; context: { form: notificationForm, field: 'adlPhone' }"></ng-container>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.shipment.localeLanguageLabel" | translate }}</mat-label>
              <mat-select formControlName="adlLocaleLanguage" required [errorStateMatcher]="errorStateMatcher">
                <mat-option *ngFor="let option of upsOptions.notificationLocaleLanguages" [value]="option.code">
                  {{ option.labelKey | translate }}
                </mat-option>
              </mat-select>
              <ng-container *ngTemplateOutlet="requiredError; context: { form: notificationForm, field: 'adlLocaleLanguage' }"></ng-container>
            </mat-form-field>
            <app-country-select
              formControlName="adlLocaleDialect"
              [label]="'printCardOrders.shipment.localeDialectCountry' | translate"
              [errorStateMatcher]="errorStateMatcher"
              [required]="true"
            ></app-country-select>
          </div>
        </div>

        <div class="notification-panel party-card">
          <div class="notification-panel__header">
            <span class="notification-panel__title">{{ "printCardOrders.shipment.uapNotificationTitle" | translate }}</span>
            <mat-icon
              class="field-help"
              [matTooltip]="'printCardOrders.shipment.hint.uapNotification' | translate"
              matTooltipPosition="above"
              [attr.aria-label]="'printCardOrders.shipment.hint.uapNotification' | translate"
            >help_outline</mat-icon>
          </div>
          <div class="form-grid party-form-grid">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.shipment.notificationChannelLabel" | translate }}</mat-label>
              <mat-select formControlName="uapChannel" required [errorStateMatcher]="errorStateMatcher">
                <mat-option *ngFor="let option of upsOptions.notificationChannels" [value]="option.code">
                  {{ option.labelKey | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="notificationForm.get('uapChannel')?.value === 'email'">
              <mat-label>{{ "printCardOrders.shipment.notificationEmail" | translate }}</mat-label>
              <input matInput formControlName="uapEmail" type="email" required [errorStateMatcher]="errorStateMatcher" />
              <ng-container *ngTemplateOutlet="emailErrors; context: { form: notificationForm, field: 'uapEmail' }"></ng-container>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="notificationForm.get('uapChannel')?.value !== 'email'">
              <mat-label>{{ "printCardOrders.shipment.notificationPhone" | translate }}</mat-label>
              <input matInput formControlName="uapPhone" type="tel" required [errorStateMatcher]="errorStateMatcher" />
              <ng-container *ngTemplateOutlet="phoneErrors; context: { form: notificationForm, field: 'uapPhone' }"></ng-container>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.shipment.localeLanguageLabel" | translate }}</mat-label>
              <mat-select formControlName="uapLocaleLanguage" required [errorStateMatcher]="errorStateMatcher">
                <mat-option *ngFor="let option of upsOptions.notificationLocaleLanguages" [value]="option.code">
                  {{ option.labelKey | translate }}
                </mat-option>
              </mat-select>
              <ng-container *ngTemplateOutlet="requiredError; context: { form: notificationForm, field: 'uapLocaleLanguage' }"></ng-container>
            </mat-form-field>
            <app-country-select
              formControlName="uapLocaleDialect"
              [label]="'printCardOrders.shipment.localeDialectCountry' | translate"
              [errorStateMatcher]="errorStateMatcher"
              [required]="true"
            ></app-country-select>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="internationalFormsForm" class="form-card party-card ups-form-card ups-form-card--wide" *ngIf="upsOptions">
      <h3>{{ "printCardOrders.shipment.sectionCustoms" | translate }}</h3>
      <div class="checkbox-with-help">
        <mat-checkbox formControlName="enabled">
          {{ "printCardOrders.shipment.customsEnabled" | translate }}
        </mat-checkbox>
        <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'customsEnabled' }"></ng-container>
      </div>
      <div class="customs-fields" *ngIf="internationalFormsForm.get('enabled')?.value">
        <div class="form-grid party-form-grid">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>
              <span class="label-with-help">
                <span>{{ "printCardOrders.shipment.formTypes" | translate }}</span>
                <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'formTypes' }"></ng-container>
              </span>
            </mat-label>
            <mat-select formControlName="formTypes" multiple [errorStateMatcher]="errorStateMatcher" [required]="internationalFormsForm.get('enabled')?.value">
              <mat-option *ngFor="let option of upsOptions.internationalFormTypes" [value]="option.code">
                {{ option.labelKey | translate }}
              </mat-option>
            </mat-select>
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'formTypes' }"></ng-container>
          </mat-form-field>
          <div class="checkbox-with-help span-full">
            <mat-checkbox formControlName="additionalDocumentIndicator">{{ "printCardOrders.shipment.additionalDocument" | translate }}</mat-checkbox>
            <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'additionalDocument' }"></ng-container>
          </div>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>
              <span class="label-with-help">
                <span>{{ "printCardOrders.shipment.termsOfShipment" | translate }}</span>
                <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'termsOfShipment' }"></ng-container>
              </span>
            </mat-label>
            <mat-select formControlName="termsOfShipment" required [errorStateMatcher]="errorStateMatcher">
              <mat-option value="">{{ "printCardOrders.shipment.none" | translate }}</mat-option>
              <mat-option *ngFor="let option of upsOptions.termsOfShipment" [value]="option.code">
                {{ option.labelKey | translate }}
              </mat-option>
            </mat-select>
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'termsOfShipment' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>
              <span class="label-with-help">
                <span>{{ "printCardOrders.shipment.reasonForExport" | translate }}</span>
                <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'reasonForExport' }"></ng-container>
              </span>
            </mat-label>
            <mat-select formControlName="reasonForExport" required [errorStateMatcher]="errorStateMatcher">
              <mat-option value="">{{ "printCardOrders.shipment.none" | translate }}</mat-option>
              <mat-option *ngFor="let option of upsOptions.reasonForExport" [value]="option.code">
                {{ option.labelKey | translate }}
              </mat-option>
            </mat-select>
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'reasonForExport' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.invoiceNumber" | translate }}</mat-label>
            <input matInput formControlName="invoiceNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>
              <span class="label-with-help">
                <span>{{ "printCardOrders.shipment.invoiceDate" | translate }}</span>
                <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'invoiceDate' }"></ng-container>
              </span>
            </mat-label>
            <input matInput formControlName="invoiceDate" placeholder="yyyyMMdd" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.purchaseOrderNumber" | translate }}</mat-label>
            <input matInput formControlName="purchaseOrderNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.currencyCode" | translate }}</mat-label>
            <input
              matInput
              formControlName="currencyCode"
              maxlength="3"
              required
              [errorStateMatcher]="errorStateMatcher"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'currencyCode' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.shipment.productDescription" | translate }}</mat-label>
            <input matInput formControlName="productDescription" required [errorStateMatcher]="errorStateMatcher" />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'productDescription' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>
              <span class="label-with-help">
                <span>{{ "printCardOrders.shipment.productCommodityCode" | translate }}</span>
                <ng-container *ngTemplateOutlet="upsHelp; context: { path: 'productCommodityCode' }"></ng-container>
              </span>
            </mat-label>
            <input matInput formControlName="productCommodityCode" />
          </mat-form-field>
          <app-country-select
            formControlName="productOriginCountry"
            class="span-full"
            [label]="'printCardOrders.shipment.productOriginCountry' | translate"
            [errorStateMatcher]="errorStateMatcher"
            [required]="true"
          ></app-country-select>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.productUnitNumber" | translate }}</mat-label>
            <input
              matInput
              formControlName="productUnitNumber"
              required
              [errorStateMatcher]="errorStateMatcher"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'productUnitNumber' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.productUnitValue" | translate }}</mat-label>
            <input
              matInput
              type="number"
              formControlName="productUnitValue"
              required
              [errorStateMatcher]="errorStateMatcher"
            />
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'productUnitValue' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.productUnitOfMeasure" | translate }}</mat-label>
            <mat-select
              formControlName="productUnitOfMeasure"
              required
              [errorStateMatcher]="errorStateMatcher"
            >
              <mat-option *ngFor="let option of upsOptions.productUnitOfMeasure" [value]="option.code">
                {{ option.labelKey | translate }}
              </mat-option>
            </mat-select>
            <ng-container *ngTemplateOutlet="requiredError; context: { form: internationalFormsForm, field: 'productUnitOfMeasure' }"></ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.shipment.comments" | translate }}</mat-label>
            <textarea matInput rows="2" formControlName="comments"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.shipment.declarationStatement" | translate }}</mat-label>
            <textarea matInput rows="3" formControlName="declarationStatement"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
    </div>

    <div
      class="actions-row"
      *ngIf="canQuoteUpsShipment || canEstimateUpsShippingCost || canAttachManualShipment"
    >
      <div class="actions-buttons">
        <button
          mat-stroked-button
          type="button"
          (click)="openUpsShopRatesDialog()"
          [disabled]="shipping || !canEstimateUpsShippingCost || hasUpsTracking || loadingPackPlan"
        >
          {{ "printCardOrders.shopRates.estimateButton" | translate }}
        </button>
        <button
          mat-stroked-button
          type="button"
          *ngIf="canAttachManualShipment"
          (click)="openAttachShipmentDialog()"
          [disabled]="shipping || hasUpsTracking || loadingPackPlan"
        >
          {{ "printCardOrders.attachShipment.button" | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          type="button"
          *ngIf="canQuoteUpsShipment"
          (click)="submitUpsShipment()"
          [disabled]="shipping || !canShipWithUps || hasUpsTracking || loadingPackPlan"
        >
          <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="shipping"></mat-spinner>
          {{ "printCardOrders.submitShipment" | translate }}
        </button>
      </div>
    </div>
  </section>

    </div>
  </div>
</div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
    <app-loading></app-loading>
  </div>
</div>

<ng-template #accessPointPickerDialog>
  <div class="app-dialog">
    <header class="app-dialog__header">
      <div class="app-dialog__header-text">
        <h2>{{ "printCardOrders.accessPoint" | translate }}</h2>
      </div>
      <button mat-icon-button type="button" (click)="closeAccessPointPicker()" [attr.aria-label]="'cancel' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="app-dialog__body access-point-picker-dialog__content">
      <div class="access-point-picker-dialog__loading" *ngIf="accessPointsLoading">
        <mat-spinner diameter="32"></mat-spinner>
      </div>

      <p
        class="access-point-picker-dialog__empty"
        *ngIf="!accessPointsLoading && accessPoints.length === 0"
      >
        {{ "cardOrders.accessPointEmpty" | translate }}
      </p>

      <app-card-order-access-point
        *ngIf="!accessPointsLoading && accessPoints.length > 0"
        [points]="accessPoints"
        [formControl]="accessPointPickerControl"
      ></app-card-order-access-point>
    </div>

    <footer class="app-dialog__footer">
      <button mat-stroked-button type="button" (click)="closeAccessPointPicker()">
        {{ "printCardOrders.cancelAccessPointChange" | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canConfirmAccessPointPicker"
        (click)="confirmAccessPointPicker()"
      >
        {{ "printCardOrders.selectAccessPoint" | translate }}
      </button>
    </footer>
  </div>
</ng-template>
